import { useState } from "react";

// react-router-dom components
import * as React from "react";
// Soft UI Dashboard React components
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import SoftInput from "components/SoftInput";
import SoftButton from "components/SoftButton";
import { IconButton } from "@mui/material";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";

// Authentication layout components
import CoverLayout from "layouts/authentication/components/CoverLayout";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { useResetpasswordMutation } from "store/api/auth.api";
import Formatmessage from "services/Formatmessage";
import useLogout from "services/Handlelogout";
import  schema  from "validationSchema/resetpassword";

function ResetPassword() {
  const [showPassword, setShowPassword] = useState(false);
  const [showconfirmPassword, setShowConfirmPassword] = useState(false);
  const [form, setForm] = useState({
    password: "",
    confirmpassword: "",
  });

  const { token } = useParams();
  const navigate = useNavigate();
  const logout = useLogout();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const [resetpassword, { isLoading, isSuccess, isError, error }] = useResetpasswordMutation();

  // hadle form validation
  const validateForm = () => {
    const result = schema.safeParse(form);

    if (!result.success) {
      
      const zodErrors = JSON.parse(result.error.message) ?? [];

      const firstMessage = zodErrors[0]?.message;
      if (firstMessage) {
        toast.error(firstMessage);
        return false;
      }
    } else {
      return true;
    }
  };

  // handle submit
  const handleSubmit = async () => {
    if (!validateForm()) return;

    const data = {
      email: localStorage.getItem("forgetPasswordMail"),
      password: form?.password?.trim(),
      token: token,
    };

    try {
      const response = await resetpassword(data).unwrap();

      if (response?.status == 1) {
        toast.success(Formatmessage(response?.message));
        localStorage.removeItem("forgetPasswordMail");
        navigate("/authentication/sign-in");
        setForm({});
      } else if (response?.status == 0) {
        toast.error(Formatmessage(response?.message));
      } else if (response?.status == 10) {
        logout();
      }
    } catch (error) {
      console.log("eror", error);
      toast.error("Server error. Please try again in a few minutes.");
    }
  };

  return (
    <CoverLayout isLogin={false}>
      <SoftBox
        width="100%"
        height="474px"
        borderRadius="xxl"
        overflow="hidden"
        sx={{ backgroundColor: "white.main" }}
        display="flex"
        flexDirection="column"
      >
        <SoftBox
          sx={{ boxSizing: "border-box", p: 0.5, backgroundColor: "secondary.main" }}
          borderRadius="xxl"
          width="100%"
        ></SoftBox>

        <SoftBox
          display="flex"
          sx={{
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            gap: 4,
            width: "100%",
            flexGrow: 1,
          }}
        >
          <SoftBox
            display="flex"
            sx={{ px: 3, py: 1, flexDirection: "column", gap: 3, width: "100%" }}
          >
            <SoftBox
              width="100%"
              display="flex"
              sx={{
                alignItems: "center",
                justifyContent: "center",
                flexDirection: "column",
              }}
            >
              <SoftTypography sx={{ fontSize: 24, color: "black.main" }}>
                Reset Password
              </SoftTypography>

              <SoftBox sx={{ textAlign: "center" }}>
                <SoftTypography
                  sx={{
                    fontSize: 16,
                    color: "lightblack.main",
                    display: { xs: "inline", lg: "block" },
                  }}
                >
                  Enter a new password for your account below.
                </SoftTypography>
              </SoftBox>
            </SoftBox>

            <SoftBox sx={{ width: "100%" }}>
              <SoftBox
                display="flex"
                flexDirection="column"
                alignItems="start"
                justifyContent="center"
                gap={1}
                sx={{ width: "100%" }}
              >
                <SoftTypography
                  color="darkgray"
                  fontWeight="bold"
                  fontSize="14px"
                  sx={{
                    fontFamily: "Montserrat, sans-serif",
                  }}
                >
                  Create New Password
                </SoftTypography>

                <SoftBox sx={{ position: "relative", height: "45px", width: "100%" }}>
                  <SoftInput
                    name="password"
                    type={showPassword ? "text" : "password"}
                    placeholder="Enter new password"
                    value={form?.password}
                    onChange={(e) => handleChange(e)}
                    fontSize="14px"
                    sx={{
                      width: "100% !important",
                      py: "15px",
                      pr: "40px",
                    }}
                  />

                  {/* Icon Button */}
                  <SoftBox
                    onClick={() => setShowPassword((prev) => !prev)}
                    sx={{
                      position: "absolute",
                      top: "60%",
                      right: "10px",
                      transform: "translateY(-50%)",
                      p: "6px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      cursor: "pointer",
                    }}
                  >
                    <IconButton
                      sx={{
                        transition: "0.3s ease-in-out",
                      }}
                    >
                      {showPassword ? (
                        <VisibilityIcon sx={{ color: "primary.main", width: 28, height: 28 }} />
                      ) : (
                        <VisibilityOffIcon sx={{ color: "primary.main", width: 28, height: 28 }} />
                      )}
                    </IconButton>
                  </SoftBox>
                </SoftBox>
              </SoftBox>
            </SoftBox>

            <SoftBox>
              <SoftBox sx={{ width: "100%" }}>
                <SoftBox
                  display="flex"
                  flexDirection="column"
                  alignItems="start"
                  justifyContent="center"
                  gap={1}
                  sx={{ width: "100%" }}
                >
                  <SoftTypography color="darkgray" fontWeight="bold" fontSize="14px">
                    Confirm New Password
                  </SoftTypography>

                  <SoftBox sx={{ position: "relative", height: "45px", width: "100%" }}>
                    <SoftInput
                      name="confirmpassword"
                      type={showPassword ? "text" : "password"}
                      onChange={(e) => handleChange(e)}
                      value={form?.confirmpassword}
                      placeholder="Re-enter password"
                      fontSize="14px"
                      sx={{
                        width: "100% !important",
                        py: "15px",
                        pr: "40px",
                      }}
                    />

                    {/* Icon Button */}
                    <SoftBox
                      onClick={() => setShowConfirmPassword((prev) => !prev)}
                      sx={{
                        position: "absolute",
                        top: "60%",
                        right: "10px",
                        transform: "translateY(-50%)",
                        p: "6px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        cursor: "pointer",
                      }}
                    >
                      <IconButton
                        sx={{
                          transition: "0.3s ease-in-out",
                        }}
                      >
                        {showconfirmPassword ? (
                          <VisibilityIcon sx={{ color: "primary.main", width: 28, height: 28 }} />
                        ) : (
                          <VisibilityOffIcon
                            sx={{ color: "primary.main", width: 28, height: 28 }}
                          />
                        )}
                      </IconButton>
                    </SoftBox>
                  </SoftBox>
                </SoftBox>
              </SoftBox>
            </SoftBox>
          </SoftBox>

          <SoftBox
            display="flex"
            sx={{
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              gap: 2,
              py: 2,
            }}
          >
            <SoftButton
              disabled={isLoading}
              onClick={handleSubmit}
              color="primary"
              variant="contained"
              sx={{ textTransform: "capitalize", fontSize: 16, width: "200px" }}
            >
              {isLoading ? "...Loading" : "Update Password"}
            </SoftButton>
          </SoftBox>
        </SoftBox>

        <SoftBox
          sx={{ boxSizing: "border-box", p: 0.5, backgroundColor: "secondary.main" }}
          borderRadius="xxl"
          width="100%"
        ></SoftBox>
      </SoftBox>
    </CoverLayout>
  );
}

export default ResetPassword;
